import { useEffect, useState } from 'react'
import { Info } from 'features/main/info'
import { Loader } from 'features/main/loader'
import { Robot } from 'features/main/robot'
import { LanguageSwitcher } from 'components/LanguageSwitcher'

import c from './splash-screen.module.scss'

export const SplashScreen = ({ isLoading, onComplete }) => {
    const [progress, setProgress] = useState(0)
    const [minTimeElapsed, setMinTimeElapsed] = useState(false)
    const startTimeRef = useState(() => Date.now())[0]

    // Минимальное время показа splash screen - 2.5 секунды
    useEffect(() => {
        const MIN_DISPLAY_TIME = 2500

        const timer = setTimeout(() => {
            setMinTimeElapsed(true)
        }, MIN_DISPLAY_TIME)

        return () => clearTimeout(timer)
    }, [])

    useEffect(() => {
        // Анимируем прогресс от 0 до 90% за 2 секунды
        const duration = 2000

        const interval = setInterval(() => {
            const elapsed = Date.now() - startTimeRef
            const newProgress = Math.min(90, (elapsed / duration) * 90)
            setProgress(Math.floor(newProgress))

            if (newProgress >= 90) {
                clearInterval(interval)
            }
        }, 50)

        return () => clearInterval(interval)
    }, [startTimeRef])

    // Доводим до 100% только когда:
    // 1. Данные загружены (!isLoading)
    // 2. Минимальное время прошло (minTimeElapsed)
    // 3. Прогресс достиг 90%
    useEffect(() => {
        if (!isLoading && minTimeElapsed && progress >= 90) {
            setProgress(100)

            // Показываем 100% на 400ms и скрываем
            const timer = setTimeout(() => {
                if (onComplete) {
                    onComplete()
                }
            }, 400)

            return () => clearTimeout(timer)
        }
    }, [isLoading, minTimeElapsed, progress, onComplete])

    return (
        <div className={c.component}>
            <LanguageSwitcher />
            <Info />
            <Robot state={0} />
            <Loader progress={progress} />
        </div>
    )
}
